import { theme } from './theme';

export const inputDefaults = {
  height: 50,
  paddingLeft: 15,
  border: `1px solid ${theme.colors.blueBlueGrey}`,
  marginBottom: 11,
};
